module.exports = __webpack_public_path__ + "img/OT495.4205791.webp";